





import { defineComponent } from "@nuxtjs/composition-api";
export default defineComponent({
  name: "WaitContent",
  setup() {
    return {
      waitContent: "Coming soon. Please contact us if you need to order.",
    };
  },
});
